import React from 'react';
import { IShipmentOption } from './types';
import { getShipmentTypesText } from './utils';
import { ShipmentIcon } from './ShipmentIcon';
import { HighlightedText } from './HighlightedText';

export interface ShipmentOptionItemProps {
  option: IShipmentOption;
  searchTerm?: string;
}

/**
 * Component for rendering individual shipment options in the dropdown
 */
export const ShipmentOptionItem: React.FC<ShipmentOptionItemProps> = ({ option, searchTerm = '' }) => {
  const typesText = getShipmentTypesText(option.deviationCount, option.approvalCount, option.isNoRateCard);
  const shipmentNumber = option.shipmentNumber || '';

  return (
    <div className='flex items-center gap-[8px]'>
      <ShipmentIcon type={option.type} status={option.status} auditStatus={option.auditStatus} />
      <div>
        <p className='text-12 xl:text-16'>{searchTerm.trim() ? <HighlightedText text={shipmentNumber} keyword={searchTerm} /> : shipmentNumber}</p>
        {option.type !== 'UNDER_REVIEW' && option.type !== 'PROCESSING' && <p className='text-12 text-[#808080]'>{typesText}</p>}
      </div>
    </div>
  );
};
